import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMicrophoneSlash } from '@fortawesome/free-solid-svg-icons';
import { throttle } from 'lodash';  // Import throttle from lodash

const SpeechControls = ({
                            listening,
                            startListening,
                            stopListening,
                            speechRecognitionSupported,
                            isSpeakingEnabled,
                            setIsSpeakingEnabled,
                            isSpeaking,  // Accept isSpeaking as a prop
                        }) => {
    // Throttling button actions to prevent rapid clicks
    const throttledStartStopListening = throttle(() => {
        if (listening) {
            stopListening();
        } else {
            startListening();
        }
    }, 10000); // Limit to once every 1 second

    const throttledToggleSpeaking = throttle(() => {
        setIsSpeakingEnabled(!isSpeakingEnabled);
    }, 10000); // Limit to once every 1 second

    return (
        <div className="speech-controls-container">
            <div className="speech-controls">
                {speechRecognitionSupported && (
                    <button
                        className="speech-button"
                        onClick={throttledStartStopListening}
                        disabled={isSpeaking}  // Disable the button when Justin is speaking
                    >
                        <FontAwesomeIcon icon={listening ? faMicrophoneSlash : faMicrophone} />
                        {listening ? " Stop Listening" : " Start Listening"}
                    </button>
                )}
                <button
                    className="speech-button"
                    onClick={throttledToggleSpeaking}
                    disabled={isSpeaking}  // Disable the button when Justin is speaking
                >
                    <FontAwesomeIcon icon={isSpeakingEnabled ? faMicrophoneSlash : faMicrophone} />
                    {isSpeakingEnabled ? " Mute Justin" : " Unmute Justin"}
                </button>
            </div>
            {isSpeaking && (
                <div className="button-overlay">
                    <div className="overlay-text">Justin is speaking...</div>
                </div>
            )}
        </div>
    );
};

export default SpeechControls;
